import styled, { css } from 'styled-components';
import { mq } from '~/styles/grid';

const PictureStyled = styled.picture`
  width: 100%;

  ${(props) =>
    props.startAfterSkew &&
    css`
      margin-left: 44%;
    `}

  img {
    ${(props) =>
      props.startAfterSkew &&
      css`
        width: 56% !important;
      `}
    ${(props) =>
      props.heroEVP &&
      css`
        object-fit: cover;
        overflow: hidden;
        height: 100%;
        object-position: center center;
      `}
  }
`;

/**
 * @param {PictureProps} props
 * @returns {React.ReactElement} The rendered component
 */
const Picture = ({
  className,
  urls,
  alt,
  title,
  startAfterSkew = false,
  heroEVP = false,
}) => {
  if (typeof window === 'undefined') {
    return <PictureStyled startAfterSkew={startAfterSkew} heroEVP={heroEVP} />;
  }

  return (
    <PictureStyled
      className={className}
      startAfterSkew={startAfterSkew}
      heroEVP={heroEVP}
    >
      {(urls.xxl || urls.xl) && (
        <source
          media={startAfterSkew ? `(${mq.xl})` : `(${mq.xxl})`}
          srcSet={startAfterSkew ? urls.xl : (urls.xxl ?? urls.xl)}
        />
      )}
      {urls.xl && <source media={`(${mq.xl})`} srcSet={urls.xl} />}
      {(urls.lg || urls.xl) && (
        <source media={`(${mq.lgUp})`} srcSet={urls.lg ?? urls.xl} />
      )}
      {urls.md && <source media={`(${mq.smUp})`} srcSet={urls.md} />}
      {urls.xs && <source media={`(${mq.xs})`} srcSet={urls.xs} />}
      <img src={urls.xl} alt={alt} title={title} />
    </PictureStyled>
  );
};

export default Picture;
